import { styled } from '@ori-ui/mui';
import { shouldForwardProp } from '@ori/presentation-utils';
import { FONT_SANS_CONDENSED_ORI, FONT_SANS_ORI } from '../../common';
export const Root = styled('a', {
  shouldForwardProp: shouldForwardProp()
})(({
  theme
}) => ({
  color: theme.palette.text.primary,
  borderRadius: 10,
  boxShadow: theme.shadows[2],
  cursor: 'pointer',
  display: 'flex',
  overflow: 'hidden',
  position: 'relative',
  textDecoration: 'none',
  '&:hover': {
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[3]
  },
  width: '100%',
  pointerEvents: 'all',
  [theme.breakpoints.up('sm')]: {
    maxWidth: 330
  },
  height: 103
}));
export const LinkArrow = styled('div', {
  shouldForwardProp: shouldForwardProp()
})(() => ({
  display: 'flex',
  fontSize: '24px',
  position: 'absolute',
  right: '3px',
  top: '50%',
  transform: 'translateY(-50%)',
  pointerEvents: 'none'
}));
export const ContentWrapper = styled('div', {
  shouldForwardProp: shouldForwardProp()
})(({
  theme,
  isUrlEmpty
}) => ({
  alignSelf: 'center',
  padding: theme.spacing(4, isUrlEmpty ? 3 : 5, 4, 3),
  pointerEvents: 'none'
}));
export const QuizTitle = styled('div', {
  shouldForwardProp: shouldForwardProp()
})(({
  theme,
  maxLines = 0
}) => ({
  fontFamily: FONT_SANS_ORI,
  fontSize: theme.typography.pxToRem(10),
  fontWeight: theme.typography.fontWeightBold,
  letterSpacing: '2px',
  marginBottom: theme.spacing(1),
  textTransform: 'uppercase',
  pointerEvents: 'none',
  display: maxLines ? '-webkit-box' : undefined,
  overflow: maxLines ? 'hidden' : undefined,
  WebkitBoxOrient: maxLines ? 'vertical' : undefined,
  WebkitLineClamp: maxLines || undefined
}));
export const QuizText = styled('div', {
  shouldForwardProp: shouldForwardProp()
})(({
  theme,
  maxLines = 0
}) => ({
  fontFamily: FONT_SANS_CONDENSED_ORI,
  fontSize: theme.typography.pxToRem(17),
  fontWeight: theme.typography.fontWeightBold,
  letterSpacing: '0',
  textTransform: 'uppercase',
  display: maxLines ? '-webkit-box' : undefined,
  overflow: maxLines ? 'hidden' : undefined,
  WebkitBoxOrient: maxLines ? 'vertical' : undefined,
  WebkitLineClamp: maxLines || undefined,
  pointerEvents: 'none'
}));
export const CatalogueDateRange = styled('div', {
  shouldForwardProp: shouldForwardProp()
})(({
  theme
}) => ({
  color: theme.palette.grey.A700,
  fontFamily: FONT_SANS_ORI,
  fontSize: theme.typography.pxToRem(10),
  fontWeight: theme.typography.fontWeightRegular,
  letterSpacing: '0.18px',
  marginBottom: theme.spacing(1),
  textTransform: 'uppercase',
  pointerEvents: 'none'
}));
export const CatalogueTitle = styled('div', {
  shouldForwardProp: shouldForwardProp()
})(({
  theme
}) => ({
  fontFamily: FONT_SANS_ORI,
  fontSize: theme.typography.pxToRem(14),
  fontWeight: theme.typography.fontWeightBold,
  pointerEvents: 'none'
}));
export const ImageWrapper = styled('div', {
  shouldForwardProp: shouldForwardProp()
})(({
  imageWidth,
  shouldWidthBeLarger
}) => ({
  minWidth: `${imageWidth}px`,
  overflow: 'hidden',
  position: 'relative',
  width: `${imageWidth}px`,
  img: {
    height: shouldWidthBeLarger ? 'unset' : '100%',
    left: shouldWidthBeLarger ? 'unset' : '50%',
    position: 'absolute',
    top: shouldWidthBeLarger ? '50%' : 'unset',
    transform: shouldWidthBeLarger ? 'translateY(-50%)' : 'translateX(-50%)',
    width: shouldWidthBeLarger ? '100%' : 'unset'
  },
  pointerEvents: 'none'
}));
//# sourceMappingURL=styles.js.map